import { cn } from '@jq4race/ui';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';

type SelectSize = 'sm' | 'md';

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  selectSize?: SelectSize;
  /** Optional class applied to the wrapping element. Use for width/layout. */
  wrapperClassName?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, wrapperClassName, children, selectSize = 'md', ...props }, ref) => {
    const sizing = selectSize === 'sm' ? 'h-9 text-[13px] pl-3 pr-8' : 'h-11 text-[15px] pl-3 pr-9';
    return (
      <div className={cn('relative inline-flex', wrapperClassName, className)}>
        <select
          ref={ref}
          className={cn(
            'w-full appearance-none rounded-sm border border-input bg-popover text-foreground',
            'font-sans transition-colors duration-200 ease-jq',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
            'disabled:cursor-not-allowed disabled:opacity-50',
            sizing,
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          aria-hidden
          className={cn(
            'pointer-events-none absolute top-1/2 -translate-y-1/2 text-jq-stone',
            selectSize === 'sm' ? 'right-2 h-3.5 w-3.5' : 'right-3 h-4 w-4',
          )}
          strokeWidth={1.5}
        />
      </div>
    );
  },
);
Select.displayName = 'Select';
